const resolveConversionObject = (conversion, conversions = []) => {
  if (!conversion) return null
  if (
    typeof conversion === 'object' &&
    (conversion.toUnit != null || conversion.toQty != null)
  ) {
    return conversion
  }

  const conversionId =
    typeof conversion === 'string' || typeof conversion === 'number'
      ? String(conversion)
      : String(
          conversion?._id || conversion?.conversionId || conversion?.id || '',
        )

  if (!conversionId) {
    return typeof conversion === 'object' ? conversion : null
  }

  return (
    conversions.find(
      candidate =>
        String(candidate?._id || '') === conversionId ||
        String(candidate?.conversionId || '') === conversionId ||
        String(candidate?.id || '') === conversionId,
    ) || (typeof conversion === 'object' ? conversion : null)
  )
}

export const resolveIngredientConversion = ingredient => {
  if (!ingredient?.conversion) return null

  const conversionCandidates = [
    ...(Array.isArray(ingredient?.conversions) ? ingredient.conversions : []),
    ...(Array.isArray(ingredient?.product?.conversions)
      ? ingredient.product.conversions
      : []),
  ]

  return resolveConversionObject(ingredient.conversion, conversionCandidates)
}

export const getIngredientsWithEmptyConversionLabels = recipe =>
  (recipe?.ingredients || [])
    .map(ingredient => {
      if (!ingredient?.conversion) return null

      const resolvedConversion = resolveIngredientConversion(ingredient)
      const conversionToCheck =
        resolvedConversion ||
        (typeof ingredient.conversion === 'object'
          ? ingredient.conversion
          : null)

      if (!conversionToCheck) return null

      if (conversionToCheck.toUnit == null && conversionToCheck.toQty == null) {
        return null
      }

      const label = String(conversionToCheck?.label || '').trim()
      if (label) return null

      return {
        title:
          ingredient?.product?.title ||
          ingredient?.title ||
          'Unknown ingredient',
        sku: ingredient?.product?.sku || '',
      }
    })
    .filter(Boolean)
